import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface IFitTableMaxDigitsCheckedFormMeta {
    pinVerification: FormInputMeta;
    local_remote: FormInputMeta;
    nbDigit: FormInputMeta;

}

const fitTableMaxDigitCheckedFormMeta = {} as IFitTableMaxDigitsCheckedFormMeta;

fitTableMaxDigitCheckedFormMeta.pinVerification = {
    name: "pinVerification",
    type: "select",
    label: "Vérification PIN",
    placeholder: "",
    validation: yup.string()
};

fitTableMaxDigitCheckedFormMeta.local_remote = {
    name: "local_remote",
    type: "select",
    label: "Local ou distant",
    placeholder: "",
    validation: yup.string()
};

fitTableMaxDigitCheckedFormMeta.nbDigit = {
    name: "nbDigit",
    type: "number",
    label: "Nb. Digit",
    placeholder: "",
    validation: yup.number().required("Champ obligatoire !")
};


export default fitTableMaxDigitCheckedFormMeta;